import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";
import * as React from "react";

export const JobIcon = (props: SvgIconProps) => {
    const { viewBox = "0 0 24 24", ...rest } = props;

    return (
        <SvgIcon viewBox={viewBox} {...rest}>
            <g>
                <g>
                    <rect x="2.1" y="11.4" fill="currentColor" width="8.5" height="1.2" />
                </g>
                <g>
                    <rect x="13.4" y="11.4" fill="currentColor" width="8" height="1.2" />
                </g>
                <g>
                    <path fill="currentColor" d="M20.7,8.5v10.8H3.3V8.5H20.7 M21.9,7.3H2.1v13.2h19.7V7.3L21.9,7.3z" />
                </g>
                <g>
                    <path fill="currentColor" d="M14,14.4h-4v-5h4V14.4z M11.2,13.2h1.6v-2.6h-1.6V13.2z" />
                </g>
                <g>
                    <path
                        fill="currentColor"
                        d="M16.4,7.3h-1.2c0-1.7-1.4-3.2-3.2-3.2S8.8,5.6,8.8,7.3H7.6c0-2.4,2-4.4,4.4-4.4S16.4,4.9,16.4,7.3z"
                    />
                </g>
            </g>
        </SvgIcon>
    );
};
